'use strict'

function isPremiumSensitiveRoute(path) {
  return path.includes('/card/') || path.includes('/message/') || path.startsWith('/c/')
}

function isFinishCardRoute(path) {
  return path.startsWith('/card/')
}

export function isPremiumCardRoute(route) {
  return isPremiumSensitiveRoute(route?.path || '')
}

export function getAdsDecision(route, options = {}) {
  const path = route?.path || ''
  const hasCardContext = Boolean(options?.hasCardContext || options?.card)
  const isPremiumCard = Boolean(options?.card?.premium_activated_at || options?.isPremiumCard)

  // Disallow ads on READ pages
  if (path.includes('/read')) {
    return { allowed: false, reason: 'read_page' }
  }

  // The finish/manage page is an organizer workspace, not an ad surface.
  if (isFinishCardRoute(path)) {
    return { allowed: false, reason: 'finish_card' }
  }

  // Disallow ads on print / pdf / admin pages if they exist
  if (
    path.includes('/print') ||
    path.includes('/pdf') ||
    path.startsWith('/admin')
  ) {
    return { allowed: false, reason: 'blocked_route' }
  }

  // Card-related pages must wait for card data before loading ads.
  if (isPremiumSensitiveRoute(path) && !hasCardContext) {
    return { allowed: false, reason: 'awaiting_card_context' }
  }

  // Disallow ads for premium cards on card-related flows.
  if (isPremiumCard && isPremiumSensitiveRoute(path)) {
    return { allowed: false, reason: 'premium_card' }
  }

  return { allowed: true, reason: 'allowed' }
}

export function isAdsAllowed(route, options = {}) {
  return getAdsDecision(route, options).allowed
}
